import { useMutation } from '@tanstack/react-query';
import { ConsentsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useConsentsControllerCreateMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['consentsControllerCreate', accessControlScope],
        mutationFn: async (args) => {
            const api = new ConsentsApi(accessControlConfig);
            return api.consentsControllerCreate(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useConsentsControllerCreateMutation.js.map